import throttle from 'lodash/throttle'

export default {
  inserted(el, binding) {
    // Optional throttle time can be passed via the binding value (default is 200ms)
    const throttleTime = (binding.value && binding.value.throttleTime) || 200

    // Synchronous handler for event validation.
    // Instead of stopping the event, we flag it with __skipCustomScroll,
    // so the default wheel action occurs but our custom scroll logic is skipped.
    const shouldSyncWheelHandler = (event) => {
      const { target } = event
      // If the target doesn't support .closest(), mark the event to skip custom scroll.
      if (!target || typeof target.closest !== 'function') {
        event.__skipCustomScroll = true
        return false
      }
      // Find the parent container we care about.
      const parent = document.getElementById('editor-middle')
      if (!parent) {
        event.__skipCustomScroll = true
        return false
      }
      // Check if the target is within the desired parent.
      const closest = target.closest('#editor-middle')
      if (!closest) {
        event.__skipCustomScroll = true
        return false
      }
      // Calculate the depth relative to #editor-middle.
      let depth = 0
      let currentElement = target
      while (currentElement && currentElement !== parent) {
        depth++
        currentElement = currentElement.parentElement
      }
      // If the event target is too deep (beyond child or grandchild), mark the event so that
      // the custom scroll handler will ignore it, while still allowing the default wheel behavior.
      if (depth > 2) {
        event.__skipCustomScroll = true
        return false
      }
      return true
    }

    const throttleHandler = throttle(() => {
      // Additional logic can be executed here, if desired.
      // This code will only run if the synchronous check allowed the event to pass.
    }, throttleTime)

    const wheelHandler = (event) => {
      // Run the synchronous validation first.
      if (!shouldSyncWheelHandler(event)) {
        return
      }
      // If validation passes, run the throttle additional logic.
      throttleHandler(event)
    }

    el.__wheelHandler__ = wheelHandler
    // Use capture: true so this listener runs early, and passive: false so we can call preventDefault if needed.
    // However, we are not preventing default behavior here; we are just marking the event to skip custom scroll handling.
    el.addEventListener('wheel', wheelHandler, { capture: true, passive: false })
  },

  unbind(el) {
    if (el.__wheelHandler__) {
      el.removeEventListener('wheel', el.__wheelHandler__, { capture: true })
      delete el.__wheelHandler__
    }
  },
}
